<template>
  <div class="formation">
    <div class="date" :class="{ selected: isSelected && currentSection === 'date' }" @click="onClicked('date')">
      {{ content.date }}
    </div>
    <div class="timeline" />
    <div class="data">
      <div class="title" :class="{ selected: isSelected && currentSection === 'title' }" @click="onClicked('title')">
        {{ content.title }}
      </div>
      <div
        v-if="content.info"
        class="info"
        :class="{ selected: isSelected && currentSection === 'info' }"
        @click="onClicked('info')"
        v-html="content.info"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormationComponent',
  props: {
    content: {
      type: Object,
      required: true,
    },
    onClicked: {
      type: Function,
      required: true,
    },
    currentSection: {
      type: String,
      default: '',
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.info,
.title,
.date {
  &:hover,
  &.selected {
    background-color: #fff9ef;
    cursor: pointer;
    border-radius: 12px;
  }
}
</style>
